<template>
  <div class="section_graph" style="text-align: center; font-size: 15px; color: #666">
    <p>
      그래프를 원활하게 보시려면
      <a href="https://www.google.com/chrome/browser/desktop/index.html" target="_blank">chrome</a> 또는
      <a href="https://www.mozilla.org/ko/firefox" target="_blank">firefox</a>등의 모던브라우저를 사용해 주세요.
    </p>
    <p style="padding-bottom: 20px">인터넷 익스플로러에서는 브라우저가 느려질 수 있습니다.</p>
    <button type="button" class="btn_function" @click="$emit('click')">그래프 보기</button>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
